var divider_viewer_rtlignore_default = {
  "divider-container": "q3ex9",
  "divider-container--double": "gSBv5",
  "divider": "Ej-5l",
  "divider--single": "NG9Ns",
  "divider--double": "A0d44",
  "divider--dashed": "IT7gt",
  "divider--dotted": "PBkoS",
  "divider--small": "fAuPZ",
  "divider--medium": "w1d1o",
  "divider--large": "tafSP",
  "divider--left": "_5--Yg",
  "divider--center": "_9rT4j",
  "divider--right": "EuqOW",
  "svgFixerContainer": "usvxq",
  "emptyChar": "Ee-Nm"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
